import i18n from 'i18next';
import { PRIVATE_COMPETITIONS } from 'utils/constants/sportsbook/private-competitions';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { Game } from 'interfaces/sportsbook-data-levels';

export const hidePrivateCompetitions = (
  game: Game,
  competitionId?: number
): Game => {
  const privateCompetitionIds =
    PRIVATE_COMPETITIONS[SpringConfigs.JURISDICTION];

  if (
    competitionId &&
    privateCompetitionIds &&
    privateCompetitionIds.includes(Number(competitionId))
  ) {
    const gameCopy: Game = JSON.parse(JSON.stringify(game));
    gameCopy.text_info = i18n.t('sportsbook.signInStatistics');

    if (game?.stats) {
      gameCopy.stats.team1_value = '-';
      gameCopy.stats.team2_value = '-';
      gameCopy.stats.add_info = null;

      const notNestedValues = ['team1_value', 'team2_value', 'add_info'];
      Object.keys(game.stats).forEach((_stat: string) => {
        const stat = _stat as keyof Game['stats'];

        if (!notNestedValues.includes(stat)) {
          gameCopy.stats[stat as keyof Game['stats']] = {
            ...gameCopy.stats[stat],
            team1_value: '-',
            team2_value: '-'
          };
        }
      });
    }

    gameCopy.info = gameCopy.info || {};
    gameCopy.info.pass_team = 'none';
    gameCopy.info.score1 = '-';
    gameCopy.info.score2 = '-';
    gameCopy.info.current_game_state = '';
    gameCopy.type = game.type;

    return gameCopy;
  }

  return game;
};
